<div mat-dialog-title>
    <h1 class="titulo-simpli">
        Código de referencia
    </h1>
</div>

@if (paso == 'ingreso') {
    <div mat-dialog-content>
        <p class="simpli-color3">Si tienes un código de referencia ingresalo a continuación.</p>

        <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Código de referencia</mat-label>
            <input matInput type="number" inputmode="numeric" [(ngModel)]="codigo" (input)="error = null" (keyup.enter)="validar()" autocomplete="off">
            @if (validando) {
                <mat-spinner color="primary" style="margin-right: 10px;" matSuffix diameter="20"></mat-spinner>
            }
            @if (error == null) {
                <mat-hint>Ingresa el código de referencia</mat-hint>
            }
        </mat-form-field>
        @if (error != null) {
            <small style="color: var(--mat-sys-error, #d32f2f);">{{error}}</small>
        }
    </div>

    <div mat-dialog-actions>
        <button type="button" mat-flat-button class="primary-button" [disabled]="validando" (click)="validar()">Validar código</button>
        <button type="button" mat-button class="label-button" mat-dialog-close>Cancelar</button>
    </div>
}

@if (paso == 'confirmacion') {
    <div mat-dialog-content>
        <div class="codigo-referencia-confirmacion">
            <span class="material-symbols-outlined">account_circle</span>
            <span>El código <strong>{{codigo}}</strong> pertenece a tu ejecutivo</span>
            <span class="codigo-referencia-nombre">{{ejecutivo?.nombre}} {{ejecutivo?.apellido}}</span>
            <span class="codigo-referencia-ayuda">Al registrarte quedarás asignado a este ejecutivo.</span>
        </div>
    </div>

    <div mat-dialog-actions>
        <div class="codigo-referencia-acciones">
            <button type="button" mat-flat-button class="primary-button" (click)="confirmar()">Confirmar ejecutivo</button>
            <button type="button" mat-button class="label-button" (click)="quitar()">
                <span style="text-decoration: underline;">Quitar código y continuar sin código</span>
            </button>
        </div>
    </div>
}
